<template>
    <div class="m-omitPassenger">
        <el-row :gutter="20" class="mt10">
            <el-col :span="12">
                <stats-chart
                    ref="genderChart"
                    type="pie"
                    title="旅客性别与违禁品"
                ></stats-chart>
            </el-col>

            <el-col :span="12">
                <stats-chart
                    ref="ageChart"
                    type="pie"
                    title="旅客年龄与违禁品"
                ></stats-chart>
            </el-col>
        </el-row>

        <el-row :gutter="20" class="mt10">
            <el-col :span="12">
                <stats-chart
                    ref="identityChart"
                    type="pie"
                    title="旅客身份与违禁品"
                ></stats-chart>
            </el-col>

            <el-col :span="12">
                <stats-chart
                    ref="transferChart"
                    type="pie"
                    title="旅客转机对违禁品的影响"
                ></stats-chart>
            </el-col>
        </el-row>

        <ui-card class="table-box mt10" title="旅客漏检记录" icon="nucfont inuc-list-chart">
            <el-form class="table-query" :inline="true" size="mini" @submit.native.prevent>
                <!--组织机构-->
                <el-form-item label="姓名">
                    <el-input v-model="formSearch.name" :placeholder="$t('tip.name')"
                              @keyup.enter.native="getTableData(1)" clearable></el-input>
                </el-form-item>

                <!-- todo: query -->

                <el-form-item>
                    <el-button type="primary" @click="getTableData(1)" round>{{ $t('c.query') }}</el-button>
                </el-form-item>
            </el-form>
            <data-tables class="omit-table"
                         :data="tableData"
                         :table-props="tableProps"
                         :current-page.sync="currentPage"
                         :page-size="20"
                         :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
            >
                <el-table-column type="index" width="40" align="center"></el-table-column>
                <el-table-column v-for="(title, index) in titles" :prop="title.prop" :label="title.label" :key="index"
                                 align="center"
                                 show-overflow-tooltip
                                 :sortable="title.sortable">
                    <template v-if="title.prop==='isTransfer'" #default="{row}">
                        {{row.isTransfer ? '是': row.isTransfer!==null? '否': ' '}}
                    </template>
                </el-table-column>
            </data-tables>
        </ui-card>
    </div>
</template>

<script>
import uiCard from '@/components/Statistics/StatisticUICard.vue'
import StatsChart from "@/components/Statistics/StatsChart"

export default {
    components: {
        uiCard,
        StatsChart
    },
    data() {
        return {
            formSearch: {
                name: '',
            },
            tableData: [],
            tableProps: {
                border: false,
                stripe: true,
                height: 360
            },
            currentPage: 1,
            titles: [
                {
                    prop: 'name',
                    label: '姓名'
                }, {
                    prop: 'genderName',
                    label: '性别',
                    sortable: 'custom'
                }, {
                    prop: 'ageRangesName',
                    label: '年龄',
                    sortable: 'custom'
                }, {
                    prop: 'passengerTypeName',
                    label: '旅客身份',
                }, {
                    prop: 'flight',
                    label: '航班',
                }, {
                    prop: 'flightNatureName',
                    label: '航班性质',
                }, {
                    prop: 'isTransfer',
                    label: '是否为转机旅客',
                    sortable: 'custom'
                }
            ],
        }
    },
    computed: {},
    mounted() {
        this.getChartData()

        this.getTableData()
    },
    methods: {
        getChartData() {
            this.$api.passengerGenderOmitTop().then(res => {
                let data = res.package
                this.$refs.genderChart.drawChart({
                    data,
                    name: ['性别', '物品种类']
                })
            })

            this.$api.passengerAgeOmitTop().then(res => {
                let data = res.package
                this.$refs.ageChart.drawChart({
                    data,
                    name: ['年龄段', '物品种类'],
                })
            })

            this.$api.passengerTypeOmitTop().then(res => {
                let data = res.package
                this.$refs.identityChart.drawChart({
                    data,
                    name: ['旅客身份', '物品种类'],
                })
            })

            this.$api.passengerTransferTop().then(res => {
                let data = res.package
                this.$refs.transferChart.drawChart({
                    data,
                    showLegend: false,
                    series: {
                        radius: ['55%', '75%']
                    }
                })
            })

        },

        async getTableData(num) {
            if (num) this.currentPage = num

            let queryData = {
                ...this.formSearch,
            }

            let res = await this.$api.queryPassengerOmit(queryData)
            this.tableData = res.package
        },
    },
}
</script>

<style lang="scss">

</style>
